import styled from 'styled-components';
import { RotateSpinLoader  } from 'react-css-loaders';

const S = {};
const defaultColor = '#CE0006';
S.LoaderWrapper = styled.div`
`;
S.RotateSpinLoader = styled(RotateSpinLoader)`
    && {
        font-size: ${({size}) => size ? size : '3px'};
        border-color: ${({color}) => color ? color+'33' : defaultColor+'33'};
        border-left-color: ${({color}) => color ? color : defaultColor};
    }
`

export default S;